function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isNumber } from '@cloud-sn/v-utils';
import { isValueOutOfRange, isMarkActive } from './utils';
import SubMixin from './mixins/sub';
export default {
  name: 'SliderSteps',
  mixins: [SubMixin],
  props: {
    lowerBound: {
      type: Number,
      default: 0
    },
    upperBound: {
      type: Number,
      default: 0
    }
  },
  computed: {
    points: function points() {
      var marks = this.marks,
          dots = this.dots,
          step = this.step,
          min = this.min,
          max = this.max;
      var r = Object.keys(marks).map(parseFloat);

      if (dots && isNumber(step)) {
        for (var i = min; i <= max; i += step) {
          if (r.indexOf(i) === -1) {
            r.push(i);
          }
        }
      }

      return r.filter(function (v) {
        return !isValueOutOfRange(v, min, max);
      }).sort(function (a, b) {
        return a - b;
      });
    },
    stepElements: function stepElements() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          vertical = this.vertical,
          marks = this.marks,
          points = this.points,
          included = this.included,
          lowerBound = this.lowerBound,
          upperBound = this.upperBound,
          dotStyle = this.dotStyle,
          activeDotStyle = this.activeDotStyle,
          calcOffset = this.calcOffset;
      var elements = [];

      for (var i = 0, l = points.length; i < l; i += 1) {
        var _className;

        var point = points[i];
        var mark = marks[point] || {};
        var isActive = isMarkActive(point, included, lowerBound, upperBound);
        var className = (_className = {}, _defineProperty(_className, "".concat(prefixCls, "-dot"), mark.isDot !== false), _defineProperty(_className, "".concat(prefixCls, "-dot-active"), isActive), _className);
        var style = vertical ? {
          bottom: "".concat(calcOffset(point), "%")
        } : {
          left: "".concat(calcOffset(point), "%")
        };
        var element = h("span", {
          "class": className,
          "style": [style, dotStyle, isActive ? activeDotStyle : null]
        });
        elements.push(element);
      }

      return elements;
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        stepElements = this.stepElements;
    return h("div", {
      "class": "".concat(prefixCls, "-step")
    }, [stepElements]);
  }
};